import { ThemeProvider } from '@mui/material';
import isEmpty from 'lodash-es/isEmpty';
import { useEffect } from 'react';
import { setLicenseKey } from 'survey-core';
import { csrfTokenCall } from 'wisestep-api';
import { theme } from 'wisestep-base';

import CustomNotification from './components/notification';
import { authInterceptor } from './interceptor/authInterceptor';
import { AppProvider } from './providers/App';
import { AppRoutes } from './routes';
import { getWorkspaceToken } from './utils/token';

setLicenseKey('ODQyNjI4ZjEtZWU2ZC00MzlkLWEzNmItNmE2MjUwOWFlMzk2OzE9MjAyNC0xMC0yNg==');

function App() {
  authInterceptor();

  useEffect(() => {
    if (isEmpty(getWorkspaceToken())) {
      csrfTokenCall();
    }
  });

  return (
    <ThemeProvider theme={theme}>
      <AppProvider>
        <CustomNotification />
        <AppRoutes />
      </AppProvider>
    </ThemeProvider>
  );
}

export default App;
